import * as OFMSUI from "react-bootstrap"; import "bootstrap/dist/css/bootstrap.min.css"; import { Field, useFormik, FormikProvider, ErrorMessage } from "formik"; import * as Yup from "yup"; import React, { useState } from "react"; import { Form } from "react-bootstrap"; import Swal from "sweetalert2/dist/sweetalert2.js";
import HousingService from "../../../Services/HousingService"; import NavigationServicesHeader from "../../../Header/NavigationServicesHeader"; import { DashboardServiceReport, formatDateForInput, generatePDF, handleDownload, handleFileChange, LabelHeader, ModuleHeader, NumberValidation, SubmitButton, todayDate } from "../../utils/commonFunctions"; import { store } from "../../../App"; import ShowAlert from "../../alert"; import { Table } from "react-bootstrap"; import { AiOutlineSearch } from "react-icons/ai"; import { MdOutlinePictureAsPdf } from "react-icons/md"; import ReactHTMLTableToExcel from "react-html-table-to-excel";
import moment from "moment-timezone";
import { FaDownload, FaFileUpload } from "react-icons/fa";
import { Modal, Button } from "react-bootstrap";

const BankBookUpdate = () => {
  const [bankNamesList, setbankNamesList] = useState([]);
  const [district, setindistrict] = useState([]); const [brsData, setbrsData] = useState([]); const [showTable, setShowTable] = useState(false); const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [saveData, setSaveData] = useState([]);


  const validationSchema = Yup.object().shape({
    bankname: Yup.string().required("required"),
    brsFromDate: Yup.string().required("required"),
    brsToDate: Yup.string().required("required"),
    file: Yup.string().when("submitMode", {
      is: "submit",
      then: (schema) => schema.required("required"),
      otherwise: (schema) => schema.notRequired()
    })
  });

  const formik = useFormik({
    initialValues: {
      bankname: "", brsFromDate: "", brsToDate: "", rows: [{ date: '', amount: '', checkbox: false }], file: "", submitMode: "fetch", transactiontype: "0"
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      if (values.submitMode === "fetch") {
        formik.setFieldValue("rows", values.rows.map(() => ({ date: "", amount: "" })));
        let params = { brsBanknameaccountno: values.bankname, brsFromDate: moment(values.brsFromDate).format("DD/MM/YYYY"), brsToDate: moment(values.brsToDate).format("DD/MM/YYYY"), brsTransaction_type: values.transactiontype }
        store.dispatch({ type: "SHOW_SPINNER" });
        HousingService.getBRSBankBookUpdate(params).then((res) => {
          if (res && res.data && res.data?.length > 0) {
            setbrsData(res.data);
            const newData = { ...formik.values };
            newData.rows = res.data.map((item) => ({
              date: moment(item.clearancedate, "DD-MM-YYYY").format("YYYY-MM-DD"),
              amount: item.brsamount
            }));
            formik.setValues(newData);
          }
          else { setbrsData([]); }
        }).catch((error) => { ShowAlert("Some error occured", "error"); console.log(error); }).finally(() => {
          store.dispatch({ type: "HIDE_SPINNER" });
          setShowTable(true);
        });
      }
      else if (values.submitMode === "submit") {
        Swal.fire({ text: "Are You Sure Want to Submit?", icon: "question", showCancelButton: true, confirmButtonColor: "#3085d6", cancelButtonColor: "#d33", confirmButtonText: "Yes", }).then((result) => {
          if (result.isConfirmed) {
            store.dispatch({ type: "SHOW_SPINNER" });
            let file = document.getElementById("file").files[0]; let formData = new FormData(); formData.append("file", file);
            HousingService.brsfileUploadUrl(formData).then((respose) => {
              if (respose.data) {
                let params = saveData.map((item) => ({
                  brsBanknameaccountno: item.banknameaccountno,
                  payment_receipt_id: item.payment_receipt_id,
                  brsChequeddreceiptno: item.cheque_dd_receipt_no,
                  brsBankdate: item.brsBankdate,
                  brsAmount: item.brsAmount,
                  brsTransaction_type: item.transaction_type === "P" ? "debit" : "credit",
                  brsuploadcopy: respose.data
                }));
                HousingService.BankBookUpdateInsertion(params).then((res) => {
                  if (res.data.responseToken === "1") {
                    ShowAlert(res.data.responseMessage, "success").then(function (isConfirm) {
                      if (isConfirm.value) {
                        setShowModal(false);
                        // history.go(0);
                        formik.setFieldValue("file", "");
                        setSelectedIndex(null);
                        formik.setFieldValue("rows", values.rows.map(() => ({ date: "", amount: "" })));
                        let params = { brsBanknameaccountno: values.bankname, brsFromDate: moment(values.brsFromDate).format("DD/MM/YYYY"), brsToDate: moment(values.brsToDate).format("DD/MM/YYYY"), brsTransaction_type: values.transactiontype }
                        store.dispatch({ type: "SHOW_SPINNER" });
                        HousingService.getBRSBankBookUpdate(params).then((res) => {
                          if (res && res.data && res.data?.length > 0) {
                            setbrsData(res.data);
                            const newData1 = { ...formik.values };
                            newData1.rows = res.data.map((item) => ({
                              date: moment(item.clearancedate, "DD-MM-YYYY").format("YYYY-MM-DD"),
                              amount: item.brsamount
                            }));
                            formik.setValues(newData1);
                          }
                          else { setbrsData([]); }
                        }).catch((error) => { ShowAlert("Some error occured", "error"); console.log(error); }).finally(() => {
                          store.dispatch({ type: "HIDE_SPINNER" });
                          setShowTable(true);
                        });
                      }
                    });
                  }
                  else {
                    ShowAlert(res.data.responseMessage, "error");
                  }
                }).catch((error) => { ShowAlert("Failed to submit", "error"); }).finally(() => { formik.setFieldValue("file", ""); setSaveData([]); store.dispatch({ type: "HIDE_SPINNER" }); });
              }
            }).catch((error) => {
              ShowAlert("Some error occurred", "error"); console.log(error);
            }).finally(() => { setShowModal(false); store.dispatch({ type: "HIDE_SPINNER" }); });

          }
        });
      }
    }
  });





  React.useEffect(() => {
    HousingService.fetchBank().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          if (item !== null) { return (<option key={i} value={item.banknameaccountno}> {item.banknameaccountno} </option>); }
        }); setbankNamesList(options);
      }
    });

    HousingService.fetchDistrictNames().then((res) => {
      const response = res.data[0].display_name;
      const username = localStorage.getItem("username");
      if (res.data) {
        if (username && username.includes("DH")) { const district = response; setindistrict(district); } else { setindistrict(response); }
      }
    });

  }, []);
  const handleSearch = event => { setSearch(event.target.value) }

  const filteredData = search.length > 0 ? brsData?.filter((item) => {
    return (
      item && Object.keys(item).some((key) => {
        const value = item[key];
        return (value !== null && value.toString().toLowerCase().includes(search.toLowerCase()));
      }));
  }) : brsData;


  const handleDateChange = (event, originalIndex) => {
    const { value } = event.target;
    if (value) {
      const amount = filteredData[originalIndex].debit ? filteredData[originalIndex].debit : filteredData[originalIndex].credit;
      formik.setFieldValue(`rows[${originalIndex}].date`, value); formik.setFieldValue(`rows[${originalIndex}].amount`, amount);
    }
  };

  const uploadClick = (detail, originalIndex) => {
    // formik.setFieldValue("file","");
    formik.resetForm({values:{...formik.values,file:""}})
    setSelectedIndex(originalIndex);
    setShowModal(true);
    setSaveData((prev) => [
      ...prev,
      {
        ...detail,
        brsAmount: formik.values.rows[originalIndex].amount,
        brsBankdate: formik.values.rows[originalIndex].date,
      },
    ]);
  };



  return (
    <>
      <NavigationServicesHeader />
      <ModuleHeader title="Bank Book Update" />
      <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "90%" }}>
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <DashboardServiceReport title="Service" />
            <OFMSUI.Row className="mb-3">
              <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}> <OFMSUI.InputGroup className=" mt-4"> <span className="label-text-style"> <b>District Name</b> </span> <div className="emptyspace3">{district}</div> </OFMSUI.InputGroup> </OFMSUI.Col>

              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                <LabelHeader title="From Date" />
                <Field name="brsFromDate" className={formik.touched.brsFromDate && formik.errors.brsFromDate ? "form-control is-invalid" : "form-control"} type="date" onChange={(e) => formik.handleChange(e)} max={todayDate} />
                {formik.touched.brsFromDate && formik.errors.brsFromDate ? (<div className="invalid-feedback"> {formik.errors.brsFromDate} </div>) : null}
              </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                <LabelHeader title="To Date" />
                <Field name="brsToDate" className={formik.touched.brsToDate && formik.errors.brsToDate ? "form-control is-invalid" : "form-control"} type="date" onChange={(e) => formik.handleChange(e)} min={formik.values.brsFromDate || ""} max={todayDate} />
                {formik.touched.brsToDate && formik.errors.brsToDate ? (<div className="invalid-feedback">{formik.errors.brsToDate}</div>) : null}
              </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="" > <LabelHeader title="Name of the Bank" /> <Field component="select" name="bankname" className={formik.touched.bankname && formik.errors.bankname ? "form-control is-invalid" : "form-control"} > <option value="">Select</option> {bankNamesList} </Field> <ErrorMessage name="bankname" component={"div"} className="text-error" /> </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="" > <LabelHeader title="Transaction Type" /> <Field component="select" name="transactiontype" className={formik.touched.transactiontype && formik.errors.transactiontype ? "form-control is-invalid" : "form-control"} > <option value="0">All</option> <option value="P">Payments</option><option value="R">Receipts</option> </Field> <ErrorMessage name="transactiontype" component={"div"} className="text-error" /> </OFMSUI.Col>
            </OFMSUI.Row>
            <OFMSUI.Row>
              <center>
                <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                  <button className="btn btn-sm" style={{ backgroundColor: "#603913", borderColor: "#603913", color: "#fff" }} type="button" onClick={() => { formik.setFieldValue("submitMode", "fetch"); formik.handleSubmit(); }}>
                    Get Details
                  </button>
                </OFMSUI.Col>
              </center>

            </OFMSUI.Row>
            {showTable && (
              <>
                <OFMSUI.Row> <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=' mb-3' > <div className='input-group'> <div className='input-group-prepend'> <div className='input-group-text group_txt11' id='btnGroupAddon' > <AiOutlineSearch /> </div> </div> <input type='text' id='#filterInput' placeholder='Search ' style={{ width: '25%' }} className='form-control input-lg' value={search} onChange={handleSearch} ></input> </div> </OFMSUI.Col>
                  <OFMSUI.Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9} className=' mb-2 float-end' >
                    <button type='button' className='btn btn-success btn-sm' style={{ float: 'right', color: '#fff', marginLeft: '3px' }} > <ReactHTMLTableToExcel id='my-table-xls-button' className='download-table-xls-button' table='my-table' filename='BankBookUpdate' sheet='tablexls' buttonText='Excel' /> </button>
                    <button className='btn btn-danger btn-sm' type='button' style={{ float: 'right', marginLeft: '3px' }}
                      onClick={() => generatePDF("my-table", "Bank Book Update", "BankBookUpdate.pdf", 5)}> PDF <MdOutlinePictureAsPdf /> </button>
                  </OFMSUI.Col>
                </OFMSUI.Row>
                <div style={{ overflow: "auto", height: "500px" }}>
                  <Table striped bordered hover id="my-table" style={{ width: "100%" }}>
                    <thead className="fw-bold" style={{ top: "0px", position: "sticky" }}> <tr className="" style={{ textAlign: "center", backgroundColor: "#f2f2f2" }} ><th colSpan={6}><h6>As Per Corporation</h6></th><th colSpan={3}><h6>As Per Bank</h6></th></tr> <tr className="table_countshead"> <th>S.No.</th> <th>Received Date</th> <th>Transaction Id</th> <th>Inst No.</th> <th style={{ textAlign: "center" }}>Payment Amount</th> <th style={{ textAlign: "center" }}>Receipt Amount</th> <th style={{ textAlign: "center" }}>Clearance Date</th> <th style={{ textAlign: "center" }}>Amount</th>  <th style={{ textAlign: "center" }}>Upload File</th></tr> </thead>
                    <tbody>
                      {filteredData?.length === 0 || filteredData === undefined ? (<tr> <td colSpan={9} style={{ fontSize: "15px", textAlign: "center" }}> No details found </td> </tr>) : (
                        filteredData.map((detail, i) => {
                          const originalIndex = brsData.findIndex(d => d.payment_receipt_id === detail.payment_receipt_id)
                          return (
                            <tr key={originalIndex}>
                              <td>{originalIndex + 1}</td> <td>{detail?.date}</td> <td>{detail?.payment_receipt_id}</td><td>{detail?.cheque_dd_receipt_no}</td> <td style={{ textAlign: "right" }}>{detail?.debit}</td>
                              <td style={{ textAlign: "right" }}>{detail?.credit}</td>

                              <td>
                                <Field
                                  type="date"
                                  name={`rows[${originalIndex}].date`}
                                  className="form-control input"
                                  max={detail.transaction_type === "P" ? formatDateForInput(detail.date) : todayDate}
                                  onChange={(event) => handleDateChange(event, originalIndex)}
                                  disabled={detail.status === "submitted"}
                                />
                              </td>

                              <td><Field type="text" name={`rows[${originalIndex}].amount`} className="form-control input"
                                disabled={true}
                                onKeyPress={(e) => NumberValidation(e)} maxLength={15} /></td>
                              <td>
                                <center>
                                  {detail.status === "submitted" ? (
                                    detail.brsuploadcopy ? (
                                      <FaDownload style={{ cursor: "pointer", color: "green", fontSize: "18px" }} title="Download File" onClick={() => handleDownload(detail.brsuploadcopy)} />
                                    ) : (
                                      <FaDownload style={{ color: "gray", fontSize: "18px" }} title="No file uploaded" />
                                    )
                                  ) : (
                                    <button
                                      type="button"
                                      disabled={
                                        !formik.values.rows[originalIndex]?.date ||
                                        !formik.values.rows[originalIndex]?.amount
                                      }
                                      onClick={() => uploadClick(detail, originalIndex)}
                                      style={{
                                        background: "none",
                                        border: "none",
                                        cursor:
                                          !formik.values.rows[originalIndex]?.date ||
                                            !formik.values.rows[originalIndex]?.amount
                                            ? "not-allowed"
                                            : "pointer",
                                      }}
                                    >
                                      <FaFileUpload fontSize="30px" style={{ color: "orange" }} />

                                    </button>
                                  )}
                                </center>
                              </td>
                            </tr>
                          )
                        })
                      )} </tbody> </Table>
                </div>
              </>
            )}
            <Modal show={showModal}
              onHide={() => {
                setShowModal(false);
                formik.setFieldValue("file", "");
                setSelectedIndex(null);
                setSaveData([]);
              }} centered >
              <Modal.Header style={{ backgroundColor: "#603913", color: "#fff" }} > <Modal.Title style={{ fontSize: "16px" }}>Verify Details and Upload Document</Modal.Title>

              </Modal.Header>

              <Modal.Body style={{ backgroundColor: "#fff", color: "#000" }}>
                {selectedIndex !== null && (
                  <>
                    <p>
                      Clearance Date:{" "}
                      <b>{moment(formik.values.rows[selectedIndex]?.date).format("DD-MM-YYYY") || "-"}</b>
                    </p>
                    <p>
                      Amount:{" "}
                      <b>{formik.values.rows[selectedIndex]?.amount || "-"}</b>
                    </p>
                  </>
                )}
                <div className="mt-3">
                  <LabelHeader title="File Upload (File name should not contain symbols or special characters.)" />
                  <div className="input-group">
                    <Field
                      type="file" name="file" id="file"
                      className={formik.touched.file && formik.errors.file ? "form-control is-invalid" : "form-control"}
                      accept="application/pdf"
                      onChange={(e) => { handleFileChange(e); formik.handleChange(e); }}
                    />
                  </div>
                  <ErrorMessage name="file" component={"div"} className="text-error" />
                  {formik.touched.file && formik.errors.file ? (<div className="invalid-feedback">{formik.errors.file}</div>) : null}
                </div>
              </Modal.Body>

              <Modal.Footer style={{ backgroundColor: "#F5F5F5" }}>
                <Button style={{ backgroundColor: "#2E7D32", borderColor: "#2E7D32" }} type="button" onClick={async () => { await formik.setFieldValue("submitMode", "submit"); await formik.validateForm(); formik.handleSubmit(); }} >
                  Confirm
                </Button>
                <Button style={{ backgroundColor: "#B71C1C", borderColor: "#B71C1C" }}
                  onClick={() => { setShowModal(false); formik.setFieldValue("file", ""); formik.setFieldValue("submitMode", ""); setSelectedIndex(null); setSaveData([]) }} > Cancel </Button>
              </Modal.Footer>
            </Modal>
          </Form>
        </FormikProvider>
      </OFMSUI.Container>
    </>
  )
}

export default BankBookUpdate


